/******************************************************************************
 * Gift Box Delivery Logic - Pickeasy
 *
 * Gift Box + Gift Box add-ons only:
 * - Automatically select Store Pickup
 * - Disable Local Delivery only
 *
 * Gift Box + any normal product:
 * - Re-enable Local Delivery
 *
 * Pickeasy DOM:
 * - #ft-options-div
 * - #delivery-option-div
 * - #pickup-option-div
 ******************************************************************************/
(function () {
  'use strict';
  const GIFT_BOX_HANDLE =
    'gift-box';
  const GIFT_WAG_HANDLES = [
    'gift-box-cheezies-wag-bag',
    'gift-box-bark-kwa-pork-wag-bag',
    'gift-box-bark-kwa-beef-wag-bag',
    'gift-box-something-fishy-wag-bag'
  ];
  let giftOnlyCart =
    false;
  let isReadingCart =
    false;
  let cartCheckTimer =
    null;
  let lastPickupClick =
    0;
  /**************************************************************************
   * Cart Helpers
   **************************************************************************/
  function isCartPage() {
    return (
      window.location.pathname ===
        '/cart' ||
      window.location.pathname
        .startsWith('/cart/')
    );
  }
  function getItemHandle(
    item
  ) {
    return String(
      item.handle ||
      item.product_handle ||
      ''
    ).toLowerCase();
  }
  function isMainGiftBox(
    item
  ) {
    const handle =
      getItemHandle(
        item
      );
    const title =
      String(
        item.product_title ||
        item.title ||
        ''
      ).toLowerCase();
    return (
      handle ===
        GIFT_BOX_HANDLE ||
      title.includes(
        'the barkaneers gift box'
      ) ||
      Boolean(
        item.properties &&
        item.properties[
          '_Birthday Gift Box'
        ] === 'Yes'
      )
    );
  }
  function isGiftWagBag(
    item
  ) {
    const handle =
      getItemHandle(
        item
      );
    const title =
      String(
        item.product_title ||
        item.title ||
        ''
      ).toLowerCase();
    return (
      GIFT_WAG_HANDLES.includes(
        handle
      ) ||
      title.startsWith(
        'gift box '
      ) ||
      Boolean(
        item.properties &&
        item.properties[
          '_Gift Box Add-on'
        ] === 'Yes'
      )
    );
  }
  function isGiftBundleItem(
    item
  ) {
    return (
      isMainGiftBox(
        item
      ) ||
      isGiftWagBag(
        item
      )
    );
  }
  /**************************************************************************
   * Pickeasy Elements
   **************************************************************************/
  function getPickeasyElements() {
    const container =
      document.getElementById(
        'ft-options-div'
      );
    const deliveryOption =
      document.getElementById(
        'delivery-option-div'
      );
    const pickupOption =
      document.getElementById(
        'pickup-option-div'
      );
    const deliveryCell =
      deliveryOption
        ? (
            deliveryOption.closest(
              '.ft-options-cell'
            ) ||
            deliveryOption
          )
        : null;
    const pickupCell =
      pickupOption
        ? (
            pickupOption.closest(
              '.ft-options-cell'
            ) ||
            pickupOption
          )
        : null;
    return {
      container:
        container,
      deliveryOption:
        deliveryOption,
      pickupOption:
        pickupOption,
      deliveryCell:
        deliveryCell,
      pickupCell:
        pickupCell
    };
  }
  /**************************************************************************
   * Remove Old / Broken State
   **************************************************************************/
  function clearLegacyDisabledState() {
    const elements =
      getPickeasyElements();
    /*
     * Previous version accidentally
     * disabled the complete Pickeasy
     * fulfillment container.
     *
     * Always clean that state.
     */
    if (
      elements.container
    ) {
      elements.container
        .classList.remove(
          'gift-box-delivery-disabled'
        );
      elements.container
        .removeAttribute(
          'aria-disabled'
        );
      elements.container
        .removeAttribute(
          'data-gift-delivery-disabled'
        );
      elements.container
        .style.removeProperty(
          'pointer-events'
        );
      elements.container
        .style.removeProperty(
          'opacity'
        );
    }
    /*
     * Pickup must NEVER have
     * the disabled class.
     */
    if (
      elements.pickupCell
    ) {
      elements.pickupCell
        .classList.remove(
          'gift-box-delivery-disabled'
        );
      elements.pickupCell
        .removeAttribute(
          'aria-disabled'
        );
      elements.pickupCell
        .removeAttribute(
          'data-gift-delivery-disabled'
        );
      elements.pickupCell
        .style.removeProperty(
          'pointer-events'
        );
      elements.pickupCell
        .style.removeProperty(
          'opacity'
        );
    }
    if (
      elements.pickupOption
    ) {
      elements.pickupOption
        .classList.remove(
          'gift-box-delivery-disabled'
        );
      elements.pickupOption
        .removeAttribute(
          'aria-disabled'
        );
      elements.pickupOption
        .removeAttribute(
          'data-gift-delivery-disabled'
        );
      elements.pickupOption
        .style.removeProperty(
          'pointer-events'
        );
      elements.pickupOption
        .style.removeProperty(
          'opacity'
        );
    }
  }
  /**************************************************************************
   * CSS
   **************************************************************************/
  function ensureStyles() {
    if (
      document.getElementById(
        'gift-box-pickeasy-styles'
      )
    ) {
      return;
    }
    const style =
      document.createElement(
        'style'
      );
    style.id =
      'gift-box-pickeasy-styles';
    style.textContent = `
      /*
       * Disable ONLY the Local Delivery cell.
       */
      .ft-options-cell.gift-box-delivery-disabled {
        opacity: 0.45 !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
      }
      .ft-options-cell.gift-box-delivery-disabled
      #delivery-option-div {
        cursor: not-allowed !important;
        pointer-events: none !important;
      }
      /*
       * Pickup always stays clickable.
       */
      #pickup-option-div,
      #pickup-option-div *,
      #pickup-option-div.closest {
        pointer-events: auto;
      }
      .gift-box-delivery-message {
        display: block;
        width: 100%;
        margin: 10px 0 16px;
        font-size: 13px;
        line-height: 1.45;
      }
    `;
    document.head.appendChild(
      style
    );
  }
  /**************************************************************************
   * Gift Box Message
   **************************************************************************/
  function removeOldMessages() {
    document
      .querySelectorAll(
        [
          '#gift-box-delivery-restriction-message',
          '#gift-box-delivery-message'
        ].join(',')
      )
      .forEach(
        function (
          element
        ) {
          element.remove();
        }
      );
  }
  function addDeliveryMessage() {
    if (
      document.getElementById(
        'gift-box-delivery-message'
      )
    ) {
      return;
    }
    const elements =
      getPickeasyElements();
    if (
      !elements.container
    ) {
      return;
    }
    const message =
      document.createElement(
        'p'
      );
    message.id =
      'gift-box-delivery-message';
    message.className =
      'gift-box-delivery-message';
    message.textContent =
      'The Birthday Gift Box is available for Store Pickup only. Add another regular product to enable Local Delivery.';
    elements.container
      .insertAdjacentElement(
        'afterend',
        message
      );
  }
  function removeDeliveryMessage() {
    const message =
      document.getElementById(
        'gift-box-delivery-message'
      );
    if (
      message
    ) {
      message.remove();
    }
  }
  /**************************************************************************
   * Pickup Active Check
   **************************************************************************/
  function isPickupActive(
    pickupOption
  ) {
    if (
      !pickupOption
    ) {
      return false;
    }
    return (
      pickupOption
        .classList.contains(
          'ft-options-active'
        ) ||
      pickupOption.getAttribute(
        'aria-selected'
      ) === 'true' ||
      pickupOption.getAttribute(
        'aria-pressed'
      ) === 'true'
    );
  }
  /**************************************************************************
   * Select Store Pickup
   **************************************************************************/
  function selectPickup() {
    const elements =
      getPickeasyElements();
    const pickupOption =
      elements.pickupOption;
    if (
      !pickupOption
    ) {
      return false;
    }
    /*
     * Already selected.
     */
    if (
      isPickupActive(
        pickupOption
      )
    ) {
      return true;
    }
    /*
     * Prevent very fast repeated
     * programmatic clicks.
     */
    const now =
      Date.now();
    if (
      now -
        lastPickupClick <
      400
    ) {
      return false;
    }
    lastPickupClick =
      now;
    console.log(
      '[Gift Box Pickeasy] Selecting Store Pickup.'
    );
    /*
     * IMPORTANT:
     *
     * Click Pickeasy's REAL pickup option.
     *
     * Do not click the parent
     * #ft-options-div.
     */
    try {
      pickupOption.click();
    } catch (
      error
    ) {
      console.error(
        '[Gift Box Pickeasy] Pickup click failed.',
        error
      );
      return false;
    }
    return true;
  }
  /**************************************************************************
   * Disable Only Local Delivery
   **************************************************************************/
  function disableDelivery() {
    const elements =
      getPickeasyElements();
    if (
      !elements.deliveryCell
    ) {
      return;
    }
    /*
     * NEVER disable the whole
     * #ft-options-div container.
     */
    if (
      elements.container
    ) {
      elements.container
        .classList.remove(
          'gift-box-delivery-disabled'
        );
      elements.container
        .removeAttribute(
          'aria-disabled'
        );
      elements.container
        .removeAttribute(
          'data-gift-delivery-disabled'
        );
    }
    /*
     * Disable only Delivery's own cell.
     */
    elements.deliveryCell
      .classList.add(
        'gift-box-delivery-disabled'
      );
    elements.deliveryCell
      .setAttribute(
        'aria-disabled',
        'true'
      );
    elements.deliveryCell
      .setAttribute(
        'data-gift-delivery-disabled',
        'true'
      );
    if (
      elements.deliveryOption
    ) {
      elements.deliveryOption
        .setAttribute(
          'aria-disabled',
          'true'
        );
      elements.deliveryOption
        .setAttribute(
          'data-gift-delivery-disabled',
          'true'
        );
    }
    addDeliveryMessage();
  }
  /**************************************************************************
   * Re-enable Local Delivery
   **************************************************************************/
  function enableDelivery() {
    const elements =
      getPickeasyElements();
    if (
      elements.deliveryCell
    ) {
      elements.deliveryCell
        .classList.remove(
          'gift-box-delivery-disabled'
        );
      elements.deliveryCell
        .removeAttribute(
          'aria-disabled'
        );
      elements.deliveryCell
        .removeAttribute(
          'data-gift-delivery-disabled'
        );
      elements.deliveryCell
        .style.removeProperty(
          'pointer-events'
        );
      elements.deliveryCell
        .style.removeProperty(
          'opacity'
        );
    }
    if (
      elements.deliveryOption
    ) {
      elements.deliveryOption
        .removeAttribute(
          'aria-disabled'
        );
      elements.deliveryOption
        .removeAttribute(
          'data-gift-delivery-disabled'
        );
      elements.deliveryOption
        .style.removeProperty(
          'pointer-events'
        );
      elements.deliveryOption
        .style.removeProperty(
          'opacity'
        );
    }
    removeDeliveryMessage();
  }
  /**************************************************************************
   * Apply Gift Box Restriction
   **************************************************************************/
  function updatePickeasyMethods() {
    if (
      !isCartPage()
    ) {
      return;
    }
    ensureStyles();
    clearLegacyDisabledState();
    const elements =
      getPickeasyElements();
    if (
      !elements.deliveryOption &&
      !elements.pickupOption
    ) {
      return;
    }
    if (
      giftOnlyCart
    ) {
      /*
       * VERY IMPORTANT ORDER:
       *
       * 1. Pickup must still be clickable.
       * 2. Select Pickup.
       * 3. Disable Delivery only.
       */
      selectPickup();
      disableDelivery();
    } else {
      enableDelivery();
    }
  }
  /**************************************************************************
   * Read Shopify Cart
   **************************************************************************/
  async function checkCart() {
    if (
      !isCartPage() ||
      isReadingCart
    ) {
      return;
    }
    isReadingCart =
      true;
    try {
      const response =
        await fetch(
          '/cart.js?gift_delivery=' +
            Date.now(),
          {
            method:
              'GET',
            headers: {
              Accept:
                'application/json'
            },
            cache:
              'no-store'
          }
        );
      if (
        !response.ok
      ) {
        throw new Error(
          'Unable to read cart.'
        );
      }
      const cart =
        await response.json();
      const hasGiftBox =
        cart.items.some(
          isMainGiftBox
        );
      const hasNormalProduct =
        cart.items.some(
          function (
            item
          ) {
            return !isGiftBundleItem(
              item
            );
          }
        );
      giftOnlyCart =
        hasGiftBox &&
        !hasNormalProduct;
      document.documentElement
        .classList.toggle(
          'gift-box-only-cart',
          giftOnlyCart
        );
      updatePickeasyMethods();
      /*
       * Pickeasy is a dynamic web component.
       * Re-check after rendering/hydration.
       */
      setTimeout(
        updatePickeasyMethods,
        200
      );
      setTimeout(
        updatePickeasyMethods,
        500
      );
      setTimeout(
        updatePickeasyMethods,
        1000
      );
      setTimeout(
        updatePickeasyMethods,
        1800
      );
      console.log(
        '[Gift Box Pickeasy]',
        {
          giftOnlyCart:
            giftOnlyCart,
          hasGiftBox:
            hasGiftBox,
          hasNormalProduct:
            hasNormalProduct
        }
      );
    } catch (
      error
    ) {
      console.error(
        '[Gift Box Pickeasy Error]',
        error
      );
    } finally {
      isReadingCart =
        false;
    }
  }
  function scheduleCartCheck() {
    clearTimeout(
      cartCheckTimer
    );
    cartCheckTimer =
      setTimeout(
        checkCart,
        250
      );
  }
  /**************************************************************************
   * Block Manual Local Delivery Selection
   **************************************************************************/
  document.addEventListener(
    'click',
    function (
      event
    ) {
      if (
        !giftOnlyCart
      ) {
        return;
      }
      const elements =
        getPickeasyElements();
      if (
        !elements.deliveryCell
      ) {
        return;
      }
      if (
        event.target ===
          elements.deliveryCell ||
        elements.deliveryCell
          .contains(
            event.target
          )
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        /*
         * Force Pickup back on.
         */
        selectPickup();
        disableDelivery();
        return false;
      }
    },
    true
  );
  /**************************************************************************
   * Cart / Page Events
   **************************************************************************/
  document.addEventListener(
    'DOMContentLoaded',
    scheduleCartCheck
  );
  window.addEventListener(
    'load',
    scheduleCartCheck
  );
  document.addEventListener(
    'cart:updated',
    scheduleCartCheck
  );
  document.addEventListener(
    'cart:refresh',
    scheduleCartCheck
  );
  document.addEventListener(
    'cart:change',
    scheduleCartCheck
  );
  /**************************************************************************
   * Pickeasy Dynamic Render Observer
   **************************************************************************/
  const observer =
    new MutationObserver(
      function () {
        if (
          !isCartPage()
        ) {
          return;
        }
        updatePickeasyMethods();
      }
    );
  function startObserver() {
    if (
      !document.body
    ) {
      return;
    }
    observer.observe(
      document.body,
      {
        childList:
          true,
        subtree:
          true
      }
    );
  }
  if (
    document.readyState ===
      'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startObserver
    );
  } else {
    startObserver();
  }
  /*
   * Safety check:
   *
   * If Pickeasy rebuilds its widget,
   * make sure Pickup stays active.
   */
  setInterval(
    function () {
      if (
        giftOnlyCart &&
        isCartPage()
      ) {
        updatePickeasyMethods();
      }
    },
    800
  );
  scheduleCartCheck();
})();
/******************************************************************************
 *********************** Gift Box Wag Bags Cart Logic *************************
 ******************************************************************************/
(function () {
  'use strict';
  const GIFT_BOX_PRODUCT_NAME =
    'the barkaneers gift box';
  const GIFT_WAG_BAG_NAMES = [
    'gift box cheezies wag bag',
    'gift box bark-kwa pork wag bag',
    'gift box bark-kwa beef wag bag',
    'gift box something fishy wag bag'
  ];
  let isGiftCleaning =
    false;
  function isCartPage() {
    return (
      window.location.pathname ===
        '/cart' ||
      window.location.pathname
        .startsWith(
          '/cart/'
        )
    );
  }
  function isGiftBoxItem(
    item
  ) {
    return Boolean(
      item &&
      item.properties &&
      item.properties[
        '_Birthday Gift Box'
      ] === 'Yes'
    );
  }
  function isGiftBoxWagBagItem(
    item
  ) {
    return Boolean(
      item &&
      item.properties &&
      item.properties[
        '_Gift Box Add-on'
      ] === 'Yes'
    );
  }
  function getGiftBundleId(
    item
  ) {
    if (
      !item ||
      !item.properties ||
      !item.properties[
        '_Gift Box Bundle ID'
      ]
    ) {
      return '';
    }
    return String(
      item.properties[
        '_Gift Box Bundle ID'
      ]
    );
  }
  function isGiftBoxRow(
    row
  ) {
    if (
      !row
    ) {
      return false;
    }
    const text =
      String(
        row.innerText ||
        ''
      ).toLowerCase();
    return (
      text.includes(
        GIFT_BOX_PRODUCT_NAME
      ) ||
      GIFT_WAG_BAG_NAMES.some(
        function (
          name
        ) {
          return text.includes(
            name
          );
        }
      )
    );
  }
  function getCartRows() {
    return Array.from(
      document.querySelectorAll(
        'tr.cart-item, .cart-item, .cart__row'
      )
    );
  }
  /**************************************************************************
   * Hide Gift Box Quantity + Price
   **************************************************************************/
  function hideGiftBoxQuantityAndPrice() {
    if (
      !isCartPage()
    ) {
      return;
    }
    getCartRows().forEach(
      function (
        row
      ) {
        if (
          !isGiftBoxRow(
            row
          )
        ) {
          return;
        }
        /*
         * Hide quantity controls only.
         */
        row.querySelectorAll(
          [
            '.quantity-popover-container',
            'quantity-input',
            '.quantity'
          ].join(',')
        ).forEach(
          function (
            element
          ) {
            element.style.setProperty(
              'display',
              'none',
              'important'
            );
          }
        );
        /*
         * Keep remove/delete button visible.
         */
        row.querySelectorAll(
          'cart-remove-button, cart-remove-button a'
        ).forEach(
          function (
            element
          ) {
            element.style.setProperty(
              'display',
              '',
              'important'
            );
            element.style.setProperty(
              'visibility',
              'visible',
              'important'
            );
            element.style.setProperty(
              'opacity',
              '1',
              'important'
            );
            element.style.setProperty(
              'pointer-events',
              'auto',
              'important'
            );
          }
        );
        /*
         * Hide price / total.
         */
        row.querySelectorAll(
          [
            '.cart-item__price-wrapper',
            '.cart-item__totals',
            '.cart__price'
          ].join(',')
        ).forEach(
          function (
            element
          ) {
            element.style.setProperty(
              'display',
              'none',
              'important'
            );
          }
        );
      }
    );
  }
  /**************************************************************************
   * Remove Button Helpers
   **************************************************************************/
  function getRemoveButton(
    target
  ) {
    if (
      !(
        target instanceof
        Element
      )
    ) {
      return null;
    }
    return target.closest(
      [
        'cart-remove-button',
        'cart-remove-button a',
        'a[href*="/cart/change"]'
      ].join(',')
    );
  }
  function getRemoveLink(
    removeButton
  ) {
    if (
      !removeButton
    ) {
      return null;
    }
    if (
      removeButton.tagName ===
        'A' &&
      removeButton.getAttribute(
        'href'
      )
    ) {
      return removeButton;
    }
    return removeButton
      .querySelector(
        'a[href*="/cart/change"]'
      );
  }
  function getTargetItem(
    removeButton,
    cart,
    cartRow
  ) {
    const removeWrapper =
      removeButton.matches(
        'cart-remove-button'
      )
        ? removeButton
        : removeButton.closest(
            'cart-remove-button'
          );
    /*
     * Dawn data-index.
     */
    if (
      removeWrapper
    ) {
      const dataIndex =
        Number(
          removeWrapper
            .getAttribute(
              'data-index'
            ) || 0
        );
      if (
        dataIndex > 0 &&
        cart.items[
          dataIndex - 1
        ]
      ) {
        return cart.items[
          dataIndex - 1
        ];
      }
    }
    const removeLink =
      getRemoveLink(
        removeButton
      );
    const href =
      removeLink
        ? (
            removeLink
              .getAttribute(
                'href'
              ) || ''
          )
        : '';
    /*
     * Try line number.
     */
    const lineMatch =
      href.match(
        /[?&]line=([^&]+)/
      );
    if (
      lineMatch &&
      lineMatch[1]
    ) {
      const lineIndex =
        Number(
          lineMatch[1]
        ) - 1;
      if (
        cart.items[
          lineIndex
        ]
      ) {
        return cart.items[
          lineIndex
        ];
      }
    }
    /*
     * Try cart item key.
     */
    const idMatch =
      href.match(
        /[?&]id=([^&]+)/
      );
    if (
      idMatch &&
      idMatch[1]
    ) {
      const itemKey =
        decodeURIComponent(
          idMatch[1]
        );
      const matchingItem =
        cart.items.find(
          function (
            item
          ) {
            return (
              item.key ===
              itemKey
            );
          }
        );
      if (
        matchingItem
      ) {
        return matchingItem;
      }
    }
    /*
     * Final fallback:
     * cart row position.
     */
    const rows =
      getCartRows();
    const rowIndex =
      rows.indexOf(
        cartRow
      );
    if (
      rowIndex >= 0 &&
      cart.items[
        rowIndex
      ]
    ) {
      return cart.items[
        rowIndex
      ];
    }
    return null;
  }
  /**************************************************************************
   * Cart API
   **************************************************************************/
  async function readCart() {
    const response =
      await fetch(
        '/cart.js?gift_remove=' +
          Date.now(),
        {
          method:
            'GET',
          headers: {
            Accept:
              'application/json'
          },
          cache:
            'no-store'
        }
      );
    if (
      !response.ok
    ) {
      throw new Error(
        'Unable to read the cart.'
      );
    }
    return response.json();
  }
  async function removeCartItems(
    updates
  ) {
    const response =
      await fetch(
        '/cart/update.js',
        {
          method:
            'POST',
          headers: {
            'Content-Type':
              'application/json',
            Accept:
              'application/json'
          },
          body:
            JSON.stringify({
              updates:
                updates
            })
        }
      );
    if (
      !response.ok
    ) {
      throw new Error(
        'Unable to update the cart.'
      );
    }
    return response.json();
  }
  /**************************************************************************
   * Linked Gift Box Removal
   **************************************************************************/
  async function processGiftRemoval(
    removeButton,
    cartRow
  ) {
    if (
      isGiftCleaning
    ) {
      return;
    }
    isGiftCleaning =
      true;
    try {
      const cart =
        await readCart();
      const targetItem =
        getTargetItem(
          removeButton,
          cart,
          cartRow
        );
      if (
        !targetItem
      ) {
        throw new Error(
          'Cart item could not be found.'
        );
      }
      const targetIsGiftBox =
        isGiftBoxItem(
          targetItem
        );
      const targetIsWagBag =
        isGiftBoxWagBagItem(
          targetItem
        );
      if (
        !targetIsGiftBox &&
        !targetIsWagBag
      ) {
        isGiftCleaning =
          false;
        return;
      }
      const updates = {};
      /*
       * Always remove clicked item.
       */
      updates[
        targetItem.key
      ] = 0;
      /*
       * Main Gift Box removed:
       * remove linked Gift Wag Bags.
       */
      if (
        targetIsGiftBox
      ) {
        const giftBundleId =
          getGiftBundleId(
            targetItem
          );
        cart.items.forEach(
          function (
            item
          ) {
            if (
              !isGiftBoxWagBagItem(
                item
              )
            ) {
              return;
            }
            const wagBundleId =
              getGiftBundleId(
                item
              );
            if (
              giftBundleId &&
              wagBundleId ===
                giftBundleId
            ) {
              updates[
                item.key
              ] = 0;
            }
          }
        );
      }
      await removeCartItems(
        updates
      );
      window.location.href =
        '/cart';
    } catch (
      error
    ) {
      console.error(
        '[Gift Box Removal Error]',
        error
      );
      isGiftCleaning =
        false;
      window.location.reload();
    }
  }
  /**************************************************************************
   * Remove Click Handler
   **************************************************************************/
  function handleGiftRemoveClick(
    event
  ) {
    if (
      !isCartPage() ||
      isGiftCleaning
    ) {
      return;
    }
    const removeButton =
      getRemoveButton(
        event.target
      );
    if (
      !removeButton
    ) {
      return;
    }
    const cartRow =
      removeButton.closest(
        'tr.cart-item, .cart-item, .cart__row'
      );
    /*
     * Do not touch normal products.
     */
    if (
      !isGiftBoxRow(
        cartRow
      )
    ) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    processGiftRemoval(
      removeButton,
      cartRow
    );
  }
  document.addEventListener(
    'click',
    handleGiftRemoveClick,
    true
  );
  /**************************************************************************
   * Cart Events
   **************************************************************************/
  document.addEventListener(
    'DOMContentLoaded',
    hideGiftBoxQuantityAndPrice
  );
  window.addEventListener(
    'load',
    hideGiftBoxQuantityAndPrice
  );
  document.addEventListener(
    'cart:updated',
    hideGiftBoxQuantityAndPrice
  );
  document.addEventListener(
    'cart:refresh',
    hideGiftBoxQuantityAndPrice
  );
  document.addEventListener(
    'cart:change',
    hideGiftBoxQuantityAndPrice
  );
  /**************************************************************************
   * Dynamic Cart Observer
   **************************************************************************/
  const giftObserver =
    new MutationObserver(
      function () {
        hideGiftBoxQuantityAndPrice();
      }
    );
  function startGiftObserver() {
    if (
      !document.body
    ) {
      return;
    }
    giftObserver.observe(
      document.body,
      {
        childList:
          true,
        subtree:
          true
      }
    );
  }
  if (
    document.readyState ===
      'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startGiftObserver
    );
  } else {
    startGiftObserver();
    hideGiftBoxQuantityAndPrice();
  }
})();
/******************************************************************************
 * Gift Box Wag Bag Safeguards
 *
 * Purpose:
 * 1. Prevent customers from opening the standalone $0 Gift Wag Bag pages.
 * 2. Disable Gift Wag Bag product links inside the cart.
 * 3. Remove any Gift Wag Bag added directly without the Gift Box add-on
 *    properties.
 * 4. Enforce a maximum of 4 linked Gift Box Wag Bags in the cart.
 ******************************************************************************/
(function () {
  'use strict';
  const GIFT_BOX_HANDLE = 'gift-box';
  const GIFT_WAG_HANDLES = [
    'gift-box-cheezies-wag-bag',
    'gift-box-bark-kwa-pork-wag-bag',
    'gift-box-bark-kwa-beef-wag-bag',
    'gift-box-something-fishy-wag-bag'
  ];
  const MAX_GIFT_WAG_BAGS = 4;
  let isCheckingGiftWagLimit = false;
  let giftWagCheckTimer = null;
  function normalizePath(path) {
    return String(path || '')
      .replace(/\/+$/, '')
      .toLowerCase();
  }
  function getItemHandle(item) {
    return String(
      (item && (item.handle || item.product_handle)) || ''
    ).toLowerCase();
  }
  function isCartPage() {
    const path = normalizePath(window.location.pathname);
    return (
      path === '/cart' ||
      path.startsWith('/cart/')
    );
  }
  function isStandaloneGiftWagProductPage() {
    const path = normalizePath(window.location.pathname);
    return GIFT_WAG_HANDLES.some(function (handle) {
      return path === '/products/' + handle;
    });
  }
  function redirectStandaloneGiftWagProduct() {
    /*
     * Keep Theme Editor usable for administrators.
     */
    if (
      window.Shopify &&
      window.Shopify.designMode
    ) {
      return;
    }
    if (!isStandaloneGiftWagProductPage()) {
      return;
    }
    window.location.replace('/products/' + GIFT_BOX_HANDLE);
  }
  function isMainGiftBoxItem(item) {
    if (!item) {
      return false;
    }
    const handle = getItemHandle(item);
    const title = String(
      item.product_title ||
      item.title ||
      ''
    ).toLowerCase();
    return (
      handle === GIFT_BOX_HANDLE ||
      title.includes('the barkaneers gift box') ||
      Boolean(
        item.properties &&
        item.properties['_Birthday Gift Box'] === 'Yes'
      )
    );
  }
  function isGiftWagHandleItem(item) {
    return GIFT_WAG_HANDLES.includes(
      getItemHandle(item)
    );
  }
  function isLinkedGiftWagItem(item) {
    return Boolean(
      item &&
      item.properties &&
      item.properties['_Gift Box Add-on'] === 'Yes'
    );
  }
  function isGiftWagItem(item) {
    return (
      isGiftWagHandleItem(item) ||
      isLinkedGiftWagItem(item)
    );
  }
  function isGiftWagProductHref(href) {
    const value = String(href || '').toLowerCase();
    return GIFT_WAG_HANDLES.some(function (handle) {
      return value.includes('/products/' + handle);
    });
  }
  function disableGiftWagProductLinks() {
    if (!isCartPage()) {
      return;
    }
    document
      .querySelectorAll('a[href*="/products/"]')
      .forEach(function (link) {
        const href = link.getAttribute('href') || '';
        if (!isGiftWagProductHref(href)) {
          return;
        }
        /*
         * Keep title/image visible, but stop navigation to the
         * standalone free add-on product page.
         */
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '-1');
        link.style.setProperty(
          'cursor',
          'default',
          'important'
        );
        link.style.setProperty(
          'pointer-events',
          'none',
          'important'
        );
        link.style.setProperty(
          'text-decoration',
          'none',
          'important'
        );
      });
  }
  async function readGiftWagCart() {
    const response = await fetch(
      '/cart.js?gift_wag_guard=' + Date.now(),
      {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        cache: 'no-store'
      }
    );
    if (!response.ok) {
      throw new Error('Unable to read the cart.');
    }
    return response.json();
  }
  async function updateGiftWagCart(updates) {
    const response = await fetch(
      '/cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates: updates
        })
      }
    );
    if (!response.ok) {
      throw new Error(
        'Unable to correct Gift Box Wag Bag quantities.'
      );
    }
    return response.json();
  }
  async function enforceGiftWagBagLimit() {
    if (
      !isCartPage() ||
      isCheckingGiftWagLimit
    ) {
      return;
    }
    isCheckingGiftWagLimit = true;
    try {
      const cart = await readGiftWagCart();
      const hasGiftBox = cart.items.some(
        isMainGiftBoxItem
      );
      const giftWagItems = cart.items.filter(
        isGiftWagItem
      );
      if (!giftWagItems.length) {
        return;
      }
      const updates = {};
      /*
       * If there is no main Gift Box, no $0 Gift Wag Bag
       * is allowed to remain in the cart.
       */
      if (!hasGiftBox) {
        giftWagItems.forEach(function (item) {
          updates[item.key] = 0;
        });
      } else {
        let remaining = MAX_GIFT_WAG_BAGS;
        /*
         * Remove every Wag Bag that was added directly from its
         * standalone product page. Legitimate bundle additions
         * always carry "_Gift Box Add-on: Yes".
         */
        giftWagItems.forEach(function (item) {
          if (!isLinkedGiftWagItem(item)) {
            updates[item.key] = 0;
          }
        });
        /*
         * Keep only the first 4 legitimate linked Gift Box
         * Wag Bags. Any excess quantity is reduced/removed.
         */
        giftWagItems
          .filter(isLinkedGiftWagItem)
          .forEach(function (item) {
            const currentQty = Math.max(
              Number(item.quantity || 0),
              0
            );
            const allowedQty = Math.min(
              currentQty,
              Math.max(remaining, 0)
            );
            if (allowedQty !== currentQty) {
              updates[item.key] = allowedQty;
            }
            remaining -= allowedQty;
          });
      }
      if (!Object.keys(updates).length) {
        return;
      }
      console.warn(
        '[Gift Box Wag Bag Guard] Correcting invalid cart quantities.',
        updates
      );
      await updateGiftWagCart(updates);
      /*
       * Reload once so cart totals, rows and Pickeasy all rebuild
       * from the corrected Shopify cart.
       */
      window.location.reload();
    } catch (error) {
      console.error(
        '[Gift Box Wag Bag Guard Error]',
        error
      );
    } finally {
      isCheckingGiftWagLimit = false;
    }
  }
  function scheduleGiftWagBagCheck() {
    if (!isCartPage()) {
      return;
    }
    clearTimeout(giftWagCheckTimer);
    giftWagCheckTimer = setTimeout(
      function () {
        disableGiftWagProductLinks();
        enforceGiftWagBagLimit();
      },
      250
    );
  }
  /*
   * Extra click protection in case a cart link is clicked before
   * its href is removed by the DOM cleanup.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (!isCartPage()) {
        return;
      }
      const target =
        event.target instanceof Element
          ? event.target.closest(
              'a[href*="/products/"]'
            )
          : null;
      if (!target) {
        return;
      }
      const href =
        target.getAttribute('href') || '';
      if (!isGiftWagProductHref(href)) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    },
    true
  );
  document.addEventListener(
    'DOMContentLoaded',
    scheduleGiftWagBagCheck
  );
  window.addEventListener(
    'load',
    scheduleGiftWagBagCheck
  );
  document.addEventListener(
    'cart:updated',
    scheduleGiftWagBagCheck
  );
  document.addEventListener(
    'cart:refresh',
    scheduleGiftWagBagCheck
  );
  document.addEventListener(
    'cart:change',
    scheduleGiftWagBagCheck
  );
  const giftWagObserver =
    new MutationObserver(function () {
      if (!isCartPage()) {
        return;
      }
      disableGiftWagProductLinks();
    });
  function startGiftWagObserver() {
    if (!document.body) {
      return;
    }
    giftWagObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }
  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startGiftWagObserver
    );
  } else {
    startGiftWagObserver();
  }
  /*
   * Run immediately. This redirects direct Wag Bag product
   * URLs before the customer can use their Add to cart button.
   */
  redirectStandaloneGiftWagProduct();
  /*
   * If the script loads after the cart DOM exists, protect it
   * immediately as well.
   */
  scheduleGiftWagBagCheck();
})();




/******************************************************************************
 * JOY FREE GIFT -> GIFT BOX CONFIGURATOR
 *
 * Problem:
 * Joy renders its Free Gift button inside <joy-loyalty-widget>.
 * Clicking Joy's "Add to cart" directly adds a default Gift Box variant.
 *
 * Solution:
 * 1. Detect interaction with the Joy widget.
 * 2. Watch for Joy attempting to add a Gift Box variant through /cart/add.
 * 3. Stop that request.
 * 4. Redirect customer to /products/gift-box.
 *
 * Normal Gift Box product page Add to Cart remains untouched.
 ******************************************************************************/

(function () {
  'use strict';

  const GIFT_BOX_URL = '/products/gift-box';
  const PRODUCT_JSON_URL = '/products/gift-box.js';

  let giftBoxVariantIds = new Set();

  /*
   * True only for a short time after the customer
   * interacts with the Joy loyalty widget.
   */
  let joyInteractionActive = false;
  let joyInteractionTimer = null;

  /*
   * -------------------------------------------------------
   * 1. LOAD ALL GIFT BOX VARIANT IDS
   * -------------------------------------------------------
   */

  const originalFetch = window.fetch.bind(window);

  function loadGiftBoxVariants() {
    return originalFetch(PRODUCT_JSON_URL, {
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Unable to load Gift Box product'
          );
        }

        return response.json();
      })
      .then(function (product) {
        if (
          !product ||
          !Array.isArray(product.variants)
        ) {
          return;
        }

        product.variants.forEach(function (variant) {
          if (variant && variant.id) {
            giftBoxVariantIds.add(
              String(variant.id)
            );
          }
        });

        console.log(
          '[Joy Gift Box] Loaded variants:',
          Array.from(giftBoxVariantIds)
        );
      })
      .catch(function (error) {
        console.warn(
          '[Joy Gift Box] Could not load variants:',
          error
        );
      });
  }

  loadGiftBoxVariants();


  /*
   * -------------------------------------------------------
   * 2. DETECT CLICK / POINTER INSIDE JOY WIDGET
   * -------------------------------------------------------
   */

  function isInsideJoyWidget(event) {
    if (!event) {
      return false;
    }

    let path = [];

    if (
      typeof event.composedPath === 'function'
    ) {
      path = event.composedPath();
    }

    /*
     * Check composed event path.
     */
    for (let i = 0; i < path.length; i++) {
      const node = path[i];

      if (
        node &&
        node.tagName &&
        String(node.tagName)
          .toLowerCase() ===
          'joy-loyalty-widget'
      ) {
        return true;
      }
    }

    /*
     * Fallback for retargeted Shadow DOM events.
     */
    const target = event.target;

    if (
      target &&
      target.closest &&
      target.closest('joy-loyalty-widget')
    ) {
      return true;
    }

    return false;
  }


  function markJoyInteraction(event) {
    if (!isInsideJoyWidget(event)) {
      return;
    }

    joyInteractionActive = true;

    clearTimeout(
      joyInteractionTimer
    );

    /*
     * A Joy cart request normally follows immediately
     * after clicking its Free Gift button.
     */
    joyInteractionTimer =
      setTimeout(function () {
        joyInteractionActive = false;
      }, 3000);
  }


  /*
   * Capture both pointer and click events.
   */
  document.addEventListener(
    'pointerdown',
    markJoyInteraction,
    true
  );

  document.addEventListener(
    'mousedown',
    markJoyInteraction,
    true
  );

  document.addEventListener(
    'click',
    markJoyInteraction,
    true
  );


  /*
   * -------------------------------------------------------
   * 3. EXTRACT VARIANT IDS FROM CART REQUEST
   * -------------------------------------------------------
   */

  function extractVariantIds(body) {
    const ids = [];

    if (!body) {
      return ids;
    }


    /*
     * FormData
     */
    if (
      typeof FormData !== 'undefined' &&
      body instanceof FormData
    ) {
      const id = body.get('id');

      if (id) {
        ids.push(String(id));
      }

      return ids;
    }


    /*
     * URLSearchParams
     */
    if (
      typeof URLSearchParams !== 'undefined' &&
      body instanceof URLSearchParams
    ) {
      const id = body.get('id');

      if (id) {
        ids.push(String(id));
      }

      return ids;
    }


    /*
     * JSON / normal string
     */
    if (typeof body === 'string') {

      /*
       * Try JSON first.
       */
      try {
        const data =
          JSON.parse(body);

        if (data.id) {
          ids.push(
            String(data.id)
          );
        }

        if (
          Array.isArray(data.items)
        ) {
          data.items.forEach(function (item) {
            if (item && item.id) {
              ids.push(
                String(item.id)
              );
            }
          });
        }

        return ids;

      } catch (error) {
        /*
         * Not JSON.
         */
      }


      /*
       * Try URL encoded form.
       */
      try {
        const params =
          new URLSearchParams(body);

        const id =
          params.get('id');

        if (id) {
          ids.push(
            String(id)
          );
        }

      } catch (error) {
        /*
         * Ignore.
         */
      }
    }


    /*
     * Plain JavaScript object.
     */
    if (
      typeof body === 'object'
    ) {

      if (body.id) {
        ids.push(
          String(body.id)
        );
      }

      if (
        Array.isArray(body.items)
      ) {
        body.items.forEach(function (item) {
          if (item && item.id) {
            ids.push(
              String(item.id)
            );
          }
        });
      }
    }

    return ids;
  }


  function containsGiftBoxVariant(ids) {

    if (!Array.isArray(ids)) {
      return false;
    }

    return ids.some(function (id) {
      return giftBoxVariantIds.has(
        String(id)
      );
    });
  }


  function isCartAddRequest(url) {
    if (!url) {
      return false;
    }

    return (
      String(url).includes(
        '/cart/add'
      )
    );
  }


  /*
   * -------------------------------------------------------
   * 4. INTERCEPT FETCH CART ADD
   * -------------------------------------------------------
   */

  window.fetch =
    function (input, options) {

      const requestUrl =
        typeof input === 'string'
          ? input
          : input && input.url
            ? input.url
            : '';

      const requestOptions =
        options || {};

      /*
       * Only inspect cart/add requests made immediately
       * after interaction with the Joy widget.
       */
      if (
        joyInteractionActive &&
        isCartAddRequest(requestUrl)
      ) {

        let body =
          requestOptions.body;

        /*
         * fetch(Request)
         */
        if (
          !body &&
          input instanceof Request
        ) {

          try {
            const cloned =
              input.clone();

            return cloned
              .text()
              .then(function (text) {

                const ids =
                  extractVariantIds(text);

                if (
                  containsGiftBoxVariant(ids)
                ) {
                  return blockJoyGiftBoxAdd();
                }

                return originalFetch(
                  input,
                  options
                );
              });

          } catch (error) {
            /*
             * Fall through to normal request.
             */
          }
        }


        const ids =
          extractVariantIds(body);

        if (
          containsGiftBoxVariant(ids)
        ) {
          return blockJoyGiftBoxAdd();
        }
      }


      return originalFetch(
        input,
        options
      );
    };


  /*
   * -------------------------------------------------------
   * 5. INTERCEPT XHR CART ADD
   * -------------------------------------------------------
   */

  const OriginalXHR =
    window.XMLHttpRequest;

  const originalOpen =
    OriginalXHR.prototype.open;

  const originalSend =
    OriginalXHR.prototype.send;


  OriginalXHR.prototype.open =
    function (
      method,
      url
    ) {

      this.__joyRequestUrl =
        url || '';

      return originalOpen.apply(
        this,
        arguments
      );
    };


  OriginalXHR.prototype.send =
    function (body) {

      if (
        joyInteractionActive &&
        isCartAddRequest(
          this.__joyRequestUrl
        )
      ) {

        const ids =
          extractVariantIds(body);

        if (
          containsGiftBoxVariant(ids)
        ) {

          console.log(
            '[Joy Gift Box] Blocked Joy XHR add-to-cart.'
          );

          joyInteractionActive =
            false;

          window.location.href =
            GIFT_BOX_URL;

          /*
           * Do NOT send request.
           */
          return;
        }
      }

      return originalSend.apply(
        this,
        arguments
      );
    };


  /*
   * -------------------------------------------------------
   * 6. REDIRECT WITHOUT ADDING PRODUCT
   * -------------------------------------------------------
   */

  function blockJoyGiftBoxAdd() {

    console.log(
      '[Joy Gift Box] Joy attempted to add Gift Box directly.'
    );

    console.log(
      '[Joy Gift Box] Blocking cart request and redirecting.'
    );

    joyInteractionActive =
      false;

    /*
     * Redirect customer to actual configurator.
     */
    window.location.href =
      GIFT_BOX_URL;


    /*
     * Give Joy a harmless successful response so
     * its JavaScript does not throw an error before
     * the redirect happens.
     */
    return Promise.resolve(
      new Response(
        JSON.stringify({
          redirected_to_gift_box: true
        }),
        {
          status: 200,
          headers: {
            'Content-Type':
              'application/json'
          }
        }
      )
    );
  }


  console.log(
    '[Joy Gift Box] Redirect interceptor initialized.'
  );

})();